import Compressor from 'compressorjs'
import BMF from 'browser-md5-file'
import { uuid } from '@/utils/shared'

// 图片压缩
export const CompressorImg = (file, quality, type) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: quality || 0.8,
      // 文件类型包含在 convertTypes 列表中且文件大小超过此值的文件将转换为JPEG。要禁用此功能，只需将值设置为 Infinity
      convertSize: 'Infinity',
      mimeType: type || 'image/webp',
      success(result) {
        resolve(result)
      },
      error(err) {
        reject(err)
      }
    })
  })
}
export const getMd5 = file => {
  return new Promise(resolve => {
    const bmf = new BMF()
    bmf.md5(file, (err, md5) => {
      if (!err) {
        resolve(md5)
      } else {
        resolve(uuid())
      }
    })
  })
}
